/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:11
 * @LastEditTime: 2020-03-05 17:07:24
 * @LastEditors: cc
 */
/**
 *  weiboSignModule
 *
 * Description 微博渠道-已签发
 * author: Qian.qianchen 2018-11-21
 */
'use strict';
angular.module('weiboSignedModule', ['weiboSignedRouterModule']).controller('weiboSignedCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'editcenterRightsService',
    '$q',
    'trsHttpService',
    'storageListenerService',
    'editingCenterService',
    'weiboConst',
    'editingMediatype',
    'messagePublishService',
    'weiboApiParams',
    'weiboApiService',
    'noticeWindowService',
    function (
        $scope,
        $state,
        modalDialog,
        editcenterRightsService,
        $q,
        trsHttpService,
        storageListenerService,
        editingCenterService,
        weiboConst,
        editingMediatype,
        messagePublishService,
        weiboApiParams,
        weiboApiService,
        noticeWindowService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                keyWords: '',
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 15,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                channelId: $state.params.wbchannelid,
                isOnlyMine: false,
                isESSearch: false,
                copyCurrPage: 1,
                keywords: '',
                mediaType: editingMediatype.weibo,
                status_model: 2,
                isEsSearch: false, // 判断是否是经过ES检索之后 
                hasRight: true,
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                docType: '',
                AccountId: $state.params.wbchannelid,
                FlowStatus: '10,0,50',
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            initDropdown();
            initBtnRights();
            // requestData();
            listenStorage();
            refreshList();
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenToWeibo(function () {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('weibo');
            }, $scope);
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [initData description] 初始化下拉框
         * @return {[type]} [description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = weiboConst.docTypeJsons;
            $scope.data.selectedDocType = weiboConst.docTypeJsons[0];
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function (event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    }
                    // 暂时的其他情况是boolean
                    else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }
        
        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.yiqianfa', $scope.status.channelId).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            let listParams = angular.extend({}, weiboApiParams.listParams, {
                PageIndex: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                StartTime: $scope.data.fromdate,
                EndTime: timeFormat($scope.data.untildate),
            }, $scope.params);
            var params = $scope.status.isEsSearch ? $scope.esparams : listParams;
            if ($scope.status.isEsSearch) {
                params.httpMethod = 'get';
            }
            $scope.loadingPromise = weiboApiService.getList(params).then(
                function (data) {
                    if (!$scope.status.isEsSearch) {
                        $scope.data.keyWords = '';
                    }
                    $scope.status.hasRight = true;
                    $scope.data.items = data.DATA;
                    !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                    deferred.resolve(data);
                },
                function (data) {
                    $scope.status.hasRight = false;
                }
            );
            return deferred.promise;
        }
        
        /**
         * [queryByDropdown description] 下拉框回调函数
         *
         * @param   {[type]}  type   [type description]
         * @param   {[type]}  value  [value description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.queryByDropdown = function(type, value) {
            $scope.page.CURRPAGE = 1;
            $scope.params[type] = value;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [timeFormat description] 日期day+1处理
         * @param  {[String]} timeStr [description]日期字符串
         * @return {[type]}         [description]
         */
        function timeFormat(timeStr) {
            if (angular.isDefined(timeStr) && timeStr != '') {
                var date = timeStr.replace(/-/g, '/');
                var timestamp = new Date(date).getTime();
                timestamp = timestamp + 24 * 60 * 60 * 1000;
                var d = new Date(timestamp);
                return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            } else {
                return '';
            }
        }

        /**
         * [fullTextSearch description] 关键字搜索
         * @param  {[type]} ev [description] event对象
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.status.isEsSearch = true;
                requestData();
            }
        };

        /**
         * [pageChanged description] 换页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.status.params.PageIndex = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [timeSelect description] 时间筛选
         * @return {[type]} [description]
         */
        $scope.timeSelect = function () {
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [deleteWeibo description] 取消签发
         * @param  {[object]} item [description] 需要取消签发的微博对象
         * @return {[type]}      [description]
         */
        $scope.deleteWeibo = function (item) {
            modalDialog.inputModel('是否取消签发', '取消签发原因 (选填)', function (content) {
                let params = angular.extend({}, weiboApiParams.cancelSignParams, {
                    MicroContentId: item.METADATAID,
                    AccountId: $state.params.wbchannelid,
                    option: content,
                });
                $scope.status.isEsSearch = false;
                $scope.loadingPromise = weiboApiService.cancelSign(params).then(
                    function (data) {
                        modalDialog.alertType('取消签发成功', '', 'success', false);
                        requestData();
                    },
                    function (data) {
                        modalDialog.alertType('取消签发失败', data.message, 'success', 'confirm');
                    }
                );
            });
        };

        /**
         * [showVersionTime description] 流程版本时间与操作日志
         * @param   {[object]}  item  [item description] 稿件对象
         * @return  {[type]}          [return description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [weiboPreview description] 微博预览
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.weiboPreview = function (item) {
            storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,PUBLISHACCOUNTIDS', 'wbPreview');
        };

        /**
         * [tenantManuShare 租户间共享]
         * @param {[object]} item [当前选中项目]
         * @return {[type]} [description]
         */
        $scope.tenantManuShare = function (item) {
            var params = {
                serviceid: 'wcm61_scmmicrocontent',
                methodname: 'pluralisticShare',
                ObjectId: item.METADATAID,
            };
            $scope.status.isEsSearch = false;
            editingCenterService.tenantShareManu(params).then(function (data) {
                if (data === 'success') {
                    requestData();
                } else {                  
                    modalDialog.alertType('租户间共享失败', '', 'error', true);              
                }
            });
        };

        /**
         * [statusFormat description] 微博视频发布状态显示格式化
         * @param  {[string]} flowStatus [description] 视频发布状态
         * @return {[String]}        [description]
         */
        $scope.statusFormat = function (flowStatus) {
            if (flowStatus === '10') {
                return '视频发布成功';
            } else if (flowStatus === '0') {
                return '视频发布失败';
            } else {
                return '视频发布中';
            }
        };

        $scope.reissue = function(item) {
            $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.status.mediaType).then(function () {
                let params = angular.extend({}, weiboApiParams.directSignParams, {
                    ObjectIds: item.METADATAID
                });
                $scope.status.isEsSearch = false;
                $scope.loadingPromise = weiboApiService.directSign(params).then(
                    function (data) {
                        modalDialog.alertType('直接签发成功', '', 'success', false);
                        requestData();
                    }
                );
            });
        };
    },
]);
